import {required} from "vuelidate/lib/validators";  
const satdosyazarfteslim = {
    data() { 
      return {   
        satdosyazarfteslimData: { 
          Sirano: 0,
          Dosyaid: "",
          Firmaid: null,
          Personelid: "",
          Teslimtarihsaat:"",
          Deleted: false,

          }, 
          FormDataType:{
            Sirano:{FieldName:"Sirano",Field:"input",FieldTitle:this.$t('satdosyazarfteslim.AddEdit.Sirano'),FieldType:"number"},
            Dosyaid:{FieldName:"Dosyaid",Field:"input"},
            Firmaid:{FieldName:"Firmaid",Field:"input",FieldTitle:this.$t('satdosyazarfteslim.AddEdit.Firmaid'),ComboDataArray:[]}, 
            Teslimtarihsaat:{FieldName:"Teslimtarihsaat",FieldTitle: this.$t('satdosyazarfteslim.AddEdit.Teslimtarihsaat')},
            Personelid:{FieldName:"Personelid",Field:"input",FieldTitle:this.$t('satdosyazarfteslim.AddEdit.Personelid'),ComboDataArray:[]}, 
          
          } 
      }
    }, 
    validations:{ 
      FormData: { 
        Sirano: { required },
        Dosyaid: { required },
        Firmaid: { required },
        Personelid: { required },
        Teslimtarihsaat: { required }
      }
 
  },
  created(){
    let Page= {
      PageNumber: "1",
      PageSize: "9999"
    }

    this.ActionsGet({ Service: "OFirma", Page: Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Firmaid.ComboDataArray.push({
          id: res.Data[i].Id,
          label: res.Data[i].Firmaadi,
        });
      }
    });

    this.ActionsGet({ Service: "OPersonel/GetAllPersonel", Page: Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Personelid.ComboDataArray.push({
          id: res.Data[i].Id,
          label: res.Data[i].AdSoyad,
        });
      }
    });


  }
}
export default satdosyazarfteslim